import { useCallback, useEffect, useState } from 'react';

const useObservable = (observable: any) => {
  const [value, setValue] = useState();
  const [error, setError] = useState();

  const listenObservable = useCallback(() => {
    const subscription = observable.subscribe(setValue, setError);
    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, [observable]);

  useEffect(() => {
    let unsubscribe: (() => void) | undefined;
    const tempTimeOut = setTimeout(() => {
      unsubscribe = listenObservable();
    }, 1);
    return () => {
      clearTimeout(tempTimeOut);
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [listenObservable, observable]);

  return [error, value];
};

export default useObservable;
